import React from 'react';
import cx from 'classnames';
import _ from 'lodash';
import Dropdown from 'components/Dropdown';
import Menu, { MenuItem } from 'components/Menu';
import { DownChevronIcon } from 'components/Svg';

export const OverlaySelectItem = ({ overlay, onSelect, ...props }) => (
  <MenuItem className="g-overlay-select-item" onClick={() => onSelect?.(overlay._id, overlay)} {...props}>
    <div>{overlay.name}</div>
  </MenuItem>
);

export const OverlaySelect = ({ overlays = [], className, size = 'm', selected, showAll = false, onChange, ...props }) => {
  let onSelect = (overlayId, overlay) => onChange?.(overlayId, overlay);
  let selectedOverlay = _.find(overlays, { _id: selected });

  return (
    <Menu 
      target={({ className: targetClassName, ...props }) => (
        <div className={cx("g-overlay-select", className, size, targetClassName)} {...props}>
          {showAll && selected === null && <div className="all-overlays">All Overlays</div>}
          {!showAll && selected === null && <div className="select-text">Select Overlay</div>}
          {selected !== null && <div className="overlay-name">Overlay: {selectedOverlay?.name}</div>}
          <DownChevronIcon />
        </div>
      )}
      position={'top left'}>
      <div className="g-overlay-select-dropdown">
        {showAll && <MenuItem onClick={() => onSelect?.(null, null)}>All Overlays</MenuItem>}
        {_.map(overlays, overlay => <OverlaySelectItem key={overlay?._id} overlay={overlay} onSelect={onSelect} />)}
      </div>
    </Menu>
  );
};

export default OverlaySelect;